import {
  GET_USER_EMAIL,
  KEYWORDS_LAST_UPDATED,
  NEXT_UPDATE_OF_KEYWORDS,
  IS_IT_TIME_FOR_UPDATE,
  TOP_100_FOR_SELECTED_KEYWORDS,
} from "../actions";

const initialState = {
  email: "",
  keywordsLastUpdated: "",
  nextUpdateOfKeywords: "",
  isItTimeForUpdate: "",
  top100ForSelectedKeywords: [],

  /* metaInformation: {},
  isLoading: false,
  isError: false, */
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_EMAIL:
      return {
        ...state,
        email: action.payload,
      };
    case KEYWORDS_LAST_UPDATED:
      return {
        ...state,
        keywordsLastUpdated: action.payload,
      };
    case NEXT_UPDATE_OF_KEYWORDS:
      return {
        ...state,
        nextUpdateOfKeywords: action.payload,
      };
    case IS_IT_TIME_FOR_UPDATE:
      return {
        ...state,
        isItTimeForUpdate: action.payload,
      };
    case TOP_100_FOR_SELECTED_KEYWORDS:
      return {
        ...state,
        top100ForSelectedKeywords: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
